import type { CheckoutStatus } from "~/types/checkout.d"

export async function getCheckoutStatus(): Promise<CheckoutStatus> {
  const sessionId = localStorage.getItem("session_id")

  const data = await api.ecommerce.get(`/rest/checkout/${sessionId}`)
  return data.data
}
